export type AuthSearch = {
  redirect?: string
}

function isSafeInternalRedirect(value: unknown): value is string {
  if (typeof value !== 'string' || !value.startsWith('/') || value.startsWith('//') || value.includes('\\')) {
    return false
  }

  for (const character of value) {
    const code = character.charCodeAt(0)
    if (code < 32 || code === 127) {
      return false
    }
  }

  return true
}

export function validateAuthSearch(search: Record<string, unknown>): AuthSearch {
  return isSafeInternalRedirect(search.redirect) ? { redirect: search.redirect } : {}
}

export function getSafeAuthRedirect(value: unknown) {
  return isSafeInternalRedirect(value) ? value : '/home'
}
